



























































































































import { Vue } from "vue-property-decorator";

interface AppState {
  isOpen: boolean;
  isCreate: boolean;
  isUpdate: boolean;
  sliceNum: Number;
  changedCate: string;
  newCate: string;
  cateColor: string;
  categories: Category[];
  infoMsg: string;
}

interface Category {
  title: string;
  value: number;
  backgroundColor: string;
}

export default Vue.extend({
  props: [],
  data() {
    const initialState: AppState = {
      isOpen: false,
      isCreate: true,
      isUpdate: false,
      sliceNum: 0,
      changedCate: "",
      newCate: "",
      cateColor: "#e66465",
      categories: this.$store.state.categories,
      infoMsg: ""
    };
    return initialState;
  },
  methods: {
    handleOpen() {
      this.isOpen = !this.isOpen;
    },
    toggleTab(param: string) {
      if (param === "create") {
        this.isCreate = true;
        this.isUpdate = false;
      } else {
        this.isCreate = false;
        this.isUpdate = true;
      }
    },
    addCate() {
      const cateItem = this.newCate;
      if (!cateItem) return;
      const newCateItem = {
        title: cateItem,
        color: this.cateColor
      };
      this.$store.commit("addNewCate", newCateItem);
      this.newCate = "";
      this.infoMsg = "카테고리가 추가되었습니다.";
      setTimeout(() => {
        this.infoMsg = "";
      }, 2000);
    },
    changeCateInfo(event: any) {
      const currentTitle = event.target.value;
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].title === currentTitle) {
          this.sliceNum = i;
        }
      }
    },
    changeExistingCate(item: Category, event: any, param: string) {
      const cateIndex = this.categories.indexOf(item);
      let msg = "색상";
      if (param === "color") {
        this.$store.commit("modifyCate", {
          backgroundColor: event.target.value,
          index: cateIndex
        });
      } else {
        if (event.target.value !== "") {
          this.$store.commit("modifyCate", {
            title: event.target.value,
            index: cateIndex
          });
          msg = "타이틀";
        }
      }
      this.infoMsg = `카테고리 ${msg}이 변경되었습니다.`;
      setTimeout(() => {
        this.infoMsg = "";
      }, 2000);
    },
    handleCateEdit(item: Category) {
      const cateIndex = this.categories.indexOf(item);
      if (this.changedCate !== "") {
        this.$store.commit("modifyCate", {
          title: this.changedCate,
          index: cateIndex
        });
      }
      this.infoMsg = "카테고리 타이틀이 변경되었습니다.";
      setTimeout(() => {
        this.infoMsg = "";
      }, 2000);
    },
    handleCateDelete(item: Category) {
      const cateIndex = this.categories.indexOf(item);
      if (cateIndex === this.categories.length - 1) this.sliceNum = 0;
      this.$store.commit("deleteCate", cateIndex);
      this.infoMsg = "카테고리가 삭제되었습니다.";
      setTimeout(() => {
        this.infoMsg = "";
      }, 2000);
    }
  }
});
